import { render, staticRenderFns } from "./OrmSubmitTaxInvoiceModal.vue?vue&type=template&id=50d86a80&scoped=true"
import script from "./OrmSubmitTaxInvoiceModal.vue?vue&type=script&lang=js"
export * from "./OrmSubmitTaxInvoiceModal.vue?vue&type=script&lang=js"
import style0 from "./OrmSubmitTaxInvoiceModal.vue?vue&type=style&index=0&id=50d86a80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d86a80",
  null
  
)

export default component.exports